import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { Person } from '../../../core/model/central/person.model';
import { Appointment } from '../../appointments/state/appointment.model';
import { STORE_FEATURE_KEY_PATIENTS } from './patients.reducers';

const patientSearchLoadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].patientSearchLoading;
const searchPatientsSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].searchPatients;
const patientDetailsLoadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].patientDetailsLoading;
const selectedPatientSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].selectedPatient;
const messagesLoadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].messagesLoading;
const setStrategyLoadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].setStrategyLoading;
const isSubscriptionUpdatedSelector = (appState: any) => appState[STORE_FEATURE_KEY_PATIENTS].isSubscriptionUpdated;

@Injectable()
export class PatientsSelectors {
    constructor(private store: Store<any>) {
    }

    selectPatientSearchLoading(): Observable<boolean> {
        return this.store.pipe(select(patientSearchLoadingSelector));
    }

    selectSearchPatients(): Observable<Array<Person>> {
        return this.store.pipe(select(searchPatientsSelector));
    }

    selectPatientDetailsLoading(): Observable<boolean> {
        return this.store.pipe(select(patientDetailsLoadingSelector));
    }

    selectSelectedPatient(): Observable<Person> {
        return this.store.pipe(select(selectedPatientSelector));
    }

    selectMessagesLoading(): Observable<boolean> {
        return this.store.pipe(select(messagesLoadingSelector));
    }

    selectSetStrategyLoading(): Observable<boolean> {
        return this.store.pipe(select(setStrategyLoadingSelector));
    }

    selectIsSubscriptionUpdated(): Observable<boolean> {
        return this.store.pipe(select(isSubscriptionUpdatedSelector));
    }
}
